


@if (hasDropmenuItems) {
  <details class="sh-navigation__dropmenu" (shClickOutside)="closeSubMenu()" #detailsElement>
    <summary class="sh-navigation__dropmenu__header" [ngClass]="{ '-sh-active': isActive$ | async }">
      <div class="sh-navigation__dropmenu__header-content-wrapper">
        @if (item.icon) {
          <svg sh-icon [name]="item.icon" aria-hidden="true" class="sh-navigation__dropmenu__header__icon"></svg>
        }
        <span class="sh-navigation__dropmenu__header__label" [title]="item.label">
          {{ item.label }}
          <sh-badge class="sh-navigation__link__badge" [badge]="item.badge"></sh-badge>
        </span>
        @if (isActive$ | async) {
          <small class="sh-navigation__dropmenu__header__sub-label">
            @if (activeSubActionItemLabel$ | async; as subItemLabel) {
              <span class="sh-truncate-text" [title]="subItemLabel">{{ subItemLabel }}</span>
            }
          </small>
        }
        @if (!openDropmenuAbove) {
          <svg
            sh-icon
            [size]="dropMenuIconSize"
            name="angle-down"
            aria-hidden="true"
            class="sh-navigation__dropmenu__marker"
          ></svg>
        }
      </div>
    </summary>
    <ul class="sh-navigation__dropmenu__list" [ngClass]="{ '-sh-open-above': openDropmenuAbove }">
      @for (dropmenuItem of item.dropmenuItems; track dropmenuItem) {
        <li class="sh-navigation__dropmenu__list__item" [title]="dropmenuItem.label">
          <a
            [shNavigationLink]="dropmenuItem.navigationLink"
            routerLinkActive="-sh-active"
            class="sh-navigation__dropmenu__link"
            (click)="closeSubMenu()"
            >
            {{ dropmenuItem.label }}
          </a>
        </li>
      }
    </ul>
  </details>
} @else {
  <a [shNavigationLink]="item.navigationLink" [ngClass]="{ '-sh-active': isActive$ | async }" class="sh-navigation__link">
    @if (item.icon) {
      <svg sh-icon [name]="item.icon" [size]="navigationIconSize" class="sh-navigation__link__icon" aria-hidden="true"></svg>
    }
    <span class="sh-navigation__link__label" [title]="item.label">{{ item.label }}</span>
    <sh-badge class="sh-navigation__link__badge" [badge]="item.badge"></sh-badge>
  </a>
}
